/**
 * Creates a object for every .components-form-Daterange DOM element.
 */
common.View.create('galaxy::common.form.inputs.Daterange', {

    options: {
        showDropdowns: true,
        locale: require('../../../common/daterangepicker').locale,
        autoUpdateInput: false,
    },

    /**
     * Called when DOM is ready.
     */
    onDOMLoad()
    {
        this.initOptions();
        this.initDatepicker();
    },

    initOptions()
    {
        // Set time on daterange
        if( this.element.find('input').data('time') || this.element.find('input').data('timeseconds') ) {
            this.options.timePicker = true;
            this.options.timePicker24Hour = true;
            this.options.locale.format = 'DD-MM-YYYY h:mm';
            this.options.locale.hiddenFormat = 'YYYY-MM-DD h:mm:ss';
        }

        // Set seconds on daterange
        if( this.element.find('input').data('seconds') || this.element.find('input').data('timeseconds') ) {
            this.options.timePickerSeconds = true;
            this.options.locale.format = 'DD-MM-YYYY h:mm:ss';
            this.options.locale.hiddenFormat = 'YYYY-MM-DD h:mm:ss';
        }
    },

    initDatepicker()
    {
        $('input[name=""]', this.element)
            .daterangepicker(this.options)
            .on('input apply.daterangepicker', this.onChange.bind(this));
    },

    onChange(ev, picker)
    {
        this.updateVisibleInput(ev, picker);
        this.updateHiddenInputs(ev, picker);
    },

    updateVisibleInput(ev, picker)
    {
        $('input[name=""]', this.element)
            .val(picker ? picker.startDate.format(this.options.locale.format)
                            + ' - '
                            + picker.endDate.format(this.options.locale.format)
                : '');
    },

    updateHiddenInputs(ev, picker)
    {
        // Loop hidden inputs.
        _.each($('input:not([name=""])', this.element), (input, index) =>
        {
            // Set value?
            if(picker)
                $(input).val(picker[index == 0 ? 'startDate' : 'endDate'].format(this.options.locale.hiddenFormat));

            // Clear value?
            else
                $(input).val('');
        });
    }

});